// Global Instructions Rule Applied!
//
// On a stored fund report or performance deck of a statement run: the
// agent-written company short descriptions it printed that still need a
// person (2026-11-03). Tag vocabulary as the row's other warnings: gold =
// needs attention (not signed off yet - signing it off on the company form
// clears it), orange = the staleness family (the company's text changed
// after the document was printed - generate it again). Nothing when nothing
// needs a person.
import React from 'react'
import { Tag, Tooltip } from 'antd'
import type { RunDescriptionWarning } from '../../../state_manager/data_models/investor_statement_run.ts'

const names = (items: RunDescriptionWarning[]) => items.map((i) => i.accounts__name || 'a company').join(', ')

export const DescriptionWarningTags: React.FC<{ items?: RunDescriptionWarning[] }> = ({ items }) => {
  const unreviewed = (items ?? []).filter((i) => i.prog__state === 'unreviewed')
  const changed = (items ?? []).filter((i) => i.prog__state === 'changed')
  return (
    <>
      {unreviewed.length > 0 ? (
        <Tooltip
          title={`It prints the agent-written short description of ${names(unreviewed)}, not yet signed off. Open the company, read the Short Description on its Details tab and press Sign off (or edit it).`}
        >
          <Tag color='gold'>
            {unreviewed.length === 1 ? 'Description not signed off' : `${unreviewed.length} descriptions not signed off`}
          </Tag>
        </Tooltip>
      ) : null}
      {changed.length > 0 ? (
        <Tooltip
          title={`The short description of ${names(changed)} changed after this document was printed: it still carries the agent's unreviewed text. Generate it again.`}
        >
          <Tag color='orange'>{changed.length === 1 ? 'Description changed' : `${changed.length} descriptions changed`}</Tag>
        </Tooltip>
      ) : null}
    </>
  )
}

export default DescriptionWarningTags
